import { Activity } from "@bentolabs/statistics-worker";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useAccount } from "wagmi";

export const useActivityInfiniteQuery = () => {
  const { address } = useAccount();

  return useInfiniteQuery({
    queryKey: ["statistics", "activity", address],
    initialPageParam: new Date().getTime(),
    queryFn: async ({ pageParam }) => {
      const response = await fetch(
        `/statistics/${address}/activities?limit=10&until=${pageParam}`
      );
      const data: Activity = await response.json();

      return data;
    },
    getNextPageParam: (lastPage, _allPages) => {
      return lastPage.timestamp;
    },
    enabled: Boolean(address),
  });
};
